export default "* Jægerstenalder\n* Beklædning\n* Naturmaterialer\n* Redskaber\n* Udsmykning\n\n";